module.exports = __webpack_public_path__ + "img/unlike.03c80d63.svg";